module.exports = __webpack_public_path__ + "static/media/p5.0eae1ce4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p5.png
// module id = 959
// module chunks = 0